<template>
  <div>
    <!-- モーダル START -->
    <b-modal width="680px" :active.sync="isShowModal" class="custom-modal">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <div class="cover-filter">
            <p class="card-header-title title">
              応募者の登録
            </p>
          </div>
        </header>
        <div class="card-content" v-if="imageUploadStep===0">
          <h2 style="width: 100%; padding-left: 16px; padding-top: 16px;">履歴書をお持ちですか？ 画像をアップロードして、カンタンに登録ができます。</h2>
          <h2 style="width: 100%; padding-left: 16px;">お持ちでない方は<b>「通常登録」</b>から登録をお願いいたします。</h2>
          <hr>
          <div style="width: 100%; display: flex; justify-content: center; padding: 16px; padding-bottom: 24px;">
            <div class="upload-button" @click="imageUploadStep=1">
              <img style="width: 170px; height: 130px; object-fit: cover;" src="@/assets/template/create_image.png"/>
              <b>画像アップロード</b>
            </div>
            <div class="newmake-button" @click="imageUploadStep=-1">
              <img style="width: 170px; height: 130px; object-fit: cover;" src="@/assets/template/create_subscribe.png"/>
              <b>通常登録</b>
            </div>
          </div>
        </div>
        <div class="card-content" v-if="imageUploadStep===-1">
          <div class="tab-box-form disp-scroll">
            <template v-if="select_manages.length > 0">
              <div class="dot-line"></div>
              <div class="tab-box-left">
                <p style="text-align: left;"><b>応募者管理画面</b></p>
              </div>
              <div :key="select_manages.pk" class="tab-box-right" style="justify-content: center;">
                <v-select
                  style="width: 100%;"
                  v-model="createSeeker.manage"
                  :options="select_manages"
                  label="name"
                  :reduce="name => name.pk"
                  multiple>
                </v-select>
              </div>
            </template>
            <template v-for="(col) in companyColumnSetting">
              <template v-if="!col.is_disabled">
                <!-- 名前 -->
                <template v-if="col.template_type == 2">
                  <div :key="'line-'+col.order_type" class="dot-line"></div>
                  <div :key="'left-'+col.order_type" class="tab-box-left">
                    <p style="text-align: left;"><b>{{ col.name }}</b></p>
                  </div>
                  <div :key="'right-'+col.order_type" class="tab-box-right" style="justify-content: center;">
                    <input style="width: 100%;" class="input is-small" v-model="createSeeker.name"/>
                  </div>
                </template>
                <!-- 名前 -->
                <template v-if="col.template_type == 3">
                  <div :key="'line-'+col.order_type" class="dot-line"></div>
                  <div :key="'left-'+col.order_type" class="tab-box-left">
                    <p style="text-align: left;"><b>{{ col.name }}</b></p>
                  </div>
                  <div :key="'right-'+col.order_type" class="tab-box-right" style="justify-content: center;">
                    <input style="width: 100%;" class="input is-small" v-model="createSeeker.name_phonetic"/>
                  </div>
                </template>
                <!-- Email -->
                <template v-if="col.template_type == 4">
                  <div :key="'line-'+col.order_type" class="dot-line"></div>
                  <div :key="'left-'+col.order_type" class="tab-box-left">
                    <p style="text-align: left;"><b>{{ col.name }}</b></p>
                  </div>
                  <div :key="'right-'+col.order_type" class="tab-box-right" style="justify-content: center;">
                    <input style="width: 100%;" class="input is-small" v-model="createSeeker.email"/>
                  </div>
                </template>
                <!-- TEL -->
                <template v-if="col.template_type == 5">
                  <div :key="'line-'+col.order_type" class="dot-line"></div>
                  <div :key="'left-'+col.order_type" class="tab-box-left">
                    <p style="text-align: left;"><b>{{ col.name }}</b></p>
                  </div>
                  <div :key="'right-'+col.order_type" class="tab-box-right" style="justify-content: center;">
                    <input style="width: 100%;" class="input is-small" v-model="createSeeker.tel"/>
                  </div>
                </template>
                <!-- 生年月日 -->
                <template v-if="col.template_type == 6">
                  <div :key="'line-'+col.order_type" class="dot-line"></div>
                  <div :key="'left-'+col.order_type" class="tab-box-left">
                    <p style="text-align: left;"><b>{{ col.name }}</b></p>
                  </div>
                  <div :key="'right-'+col.order_type" class="tab-box-right" style="justify-content: center;">
                    <div @click="openDatePicker" class="date-input-wrapper">
                      <input
                        :value="formattedDate"
                        readonly
                        placeholder="生年月日を設定"
                        class="date-input"
                      >
                    </div>
                  </div>
                </template>
                <!-- 住所 -->
                <template v-if="col.template_type == 7">
                  <div :key="'line-'+col.order_type" class="dot-line"></div>
                  <div :key="'left-'+col.order_type" class="tab-box-left">
                    <p style="text-align: left;"><b>{{ col.name }}</b></p>
                  </div>
                  <div :key="'right-'+col.order_type" class="tab-box-right" style="justify-content: center;">
                    <input style="width: 100%;" class="input is-small" v-model="createSeeker.address"/>
                  </div>
                </template>
                <!-- 性別 -->
                <template v-if="col.template_type == 9">
                  <div :key="'line-'+col.order_type" class="dot-line"></div>
                  <div :key="'left-'+col.order_type" class="tab-box-left">
                    <p style="text-align: left;"><b>{{ col.name }}</b></p>
                  </div>
                  <div :key="'right-'+col.order_type" class="tab-box-right" style="justify-content: center;">
                    <select class="select is-small is-fullwidth" v-model="createSeeker.sex">
                      <option v-for="(s, i) in sexTypes" :key="i" :value="i">{{s}}</option>
                    </select>
                  </div>
                </template>
                <!-- 状況 -->
                <template v-if="col.template_type == 10">
                  <div :key="'line-'+col.order_type" class="dot-line"></div>
                  <div :key="'left-'+col.order_type" class="tab-box-left">
                    <p style="text-align: left;"><b>{{ col.name }}</b></p>
                  </div>
                  <div :key="'right-'+col.order_type" class="tab-box-right" style="justify-content: center;">
                    <select class="select is-small is-fullwidth" v-model="createSeeker.progress_rate">
                      <option v-for="option in options" v-bind:value="option.value" :key="option.value + '-col13'">
                          {{ option.text }}
                      </option>
                    </select>
                  </div>
                </template>
                <!-- 応募日 -->
                <template v-if="col.template_type == 11">
                  <div :key="'line-'+col.order_type" class="dot-line"></div>
                  <div :key="'left-'+col.order_type" class="tab-box-left">
                    <p style="text-align: left;"><b>{{ col.name }}</b></p>
                  </div>
                  <div :key="'right-'+col.order_type" class="tab-box-right" style="justify-content: center;">
                    <b-datepicker
                      locale="ja-JP"
                      style="width: 100%;"
                      v-model="createSeeker.subscribe_date"
                      placeholder="応募日を設定"
                      size="is-small"
                      icon="calendar-today">
                    </b-datepicker>
                  </div>
                </template>
                <!-- 備考 -->
                <template v-if="col.template_type == 13">
                  <div :key="'line-'+col.order_type" class="dot-line"></div>
                  <div :key="'left-'+col.order_type" class="tab-box-left">
                    <p style="text-align: left;"><b>{{ col.name }}</b></p>
                  </div>
                  <div :key="'right-'+col.order_type" class="tab-box-right" style="justify-content: center;">
                    <input style="width: 100%;" class="input is-small" v-model="createSeeker.message"/>
                  </div>
                </template>
                <!-- 媒体連携資格 -->
                <template v-if="col.template_type == 29">
                  <div :key="'line-'+col.order_type" class="dot-line"></div>
                  <div :key="'left-'+col.order_type" class="tab-box-left">
                    <p style="text-align: left;"><b>{{ col.name }}</b></p>
                  </div>
                  <div :key="'right-'+col.order_type" class="tab-box-right" style="justify-content: center;">
                    <textarea style="width: 100%; min-width: 100%" rows="3" class="textarea is-small disp-scroll" v-model="createSeeker.recruitment_media_qualification" />
                  </div>
                </template>
                <!-- カスタムカラム -->
                <template v-if="col.template_type == 0 && col.is_pulldown_flg == 0 && col.type_for_custom_column != 3">
                  <div :key="'line-'+col.order_type" class="dot-line"></div>
                  <div :key="'left-'+col.order_type" class="tab-box-left">
                    <p style="text-align: left;"><b>{{col.name}}</b></p>
                  </div>
                  <div :key="'right-'+col.order_type" class="tab-box-right" style="justify-content: center;">
                    <input style="width: 100%;" class="input is-small" v-model="custom[col.pk]"/>
                  </div>
                </template>
                <template v-else-if="col.template_type == 0 && col.is_pulldown_flg == 1">
                  <div :key="'line-'+col.order_type" class="dot-line"></div>
                  <div :key="'left-'+col.order_type" class="tab-box-left">
                    <p style="text-align: left;"><b>{{col.name}}</b></p>
                  </div>
                  <div :key="'right-'+col.order_type" class="tab-box-right" style="justify-content: center;">
                    <select
                      class="select is-small is-fullwidth"
                      v-model="custom[col.pk]"
                    >
                      <option value="">選択してください</option>
                      <option
                        v-for="option in getOptionsForColumn(col.pk)"
                        :value="option.name"
                        :key="option.id"
                      >
                        {{ option.name }}
                      </option>
                    </select>
                  </div>
                </template>
                <template v-else-if="col.template_type == 0 && col.type_for_custom_column == 3">
                  <div :key="'line-'+col.order_type" class="dot-line"></div>
                  <div :key="'left-'+col.order_type" class="tab-box-left">
                    <p style="text-align: left;"><b>{{col.name}}</b></p>
                  </div>
                  <div :key="'right-'+col.order_type" class="tab-box-right" style="justify-content: center;">
                    <input type="date" style="width: 100%;" class="input is-small" v-model="custom[col.pk]"/>
                  </div>
                </template>
              </template>
            </template>
          </div>
          <hr>
          <div style="display: flex; justify-content: center; align-items: center;">
            <button class="button" style="width: 100px;" @click="initContent();imageUploadStep=0">戻る</button>
            <button class="button is-primary" style="margin-left: 16px; width: 100px;" @click="createSeekerMethod()" :disabled="isSubmitting">登録</button>
          </div>
        </div>
        <div class="card-content" style="padding: 0;" v-if="imageUploadStep===1">
          <h2 style="width: 100%; padding-left: 16px; padding-top: 16px;">画像のアップロードから履歴書が登録できます。</h2>
          <h2 style="width: 100%; padding-left: 16px;">カメラなどで左半分・右半分とお取りいただき、画像をアップロードしてください。</h2>
          <hr>
          <div style="width: 80%; height: 80%; display: flex; justify-content: space-between; padding: 8px; margin: 0 auto;">
            <div style="width: 49%; height: 100%;">
              <div class="wrapper-cover-img">
                <div style="position: absolute; display: flex; justify-content: center; align-items: center; z-index: 1; width: 100%; height: 100%; color: white; font-size: 120px; background: rgba(0, 0, 0, 0.5);">
                  A
                </div>
                <img src="@/assets/template/resume_A.jpeg" style="width: 70%; height: auto;"/>
              </div>
              <b-upload style="margin-top: 16px;" v-model="fileLeft">
                <a class="button is-primary">左半分をアップロード</a>
              </b-upload>
              <p v-if="fileLeft != null">アップロード完了</p>
            </div>
            <div style="width: 49%; height: 100%;">
              <div class="wrapper-cover-img">
                <div style="position: absolute; display: flex; justify-content: center; align-items: center; z-index: 1; width: 100%; height: 100%; color: white; font-size: 120px; background: rgba(0, 0, 0, 0.5);">
                  B
                </div>
                <img src="@/assets/template/resume_B.jpeg" style="width: 70%; height: auto;"/>
              </div>
              <b-upload style="margin-top: 16px;" v-model="fileRight">
                <a class="button is-primary">右半分をアップロード</a>
              </b-upload>
              <p v-if="fileRight != null">アップロード完了</p>
            </div>
          </div>
          <hr>
          <div style="height: 64px; display: flex; justify-content: center;">
            <button class="button" style="width: 200px;" @click="imageUploadStep=0">戻る</button>
            <button class="button is-primary" style="margin-left: 16px; width: 200px;" @click="registerOCR()" :disabled="ocrResumeRows.length<2">読み込む</button>
          </div>
        </div>
        <div class="card-content" style="padding: 0;" v-if="imageUploadStep===2">
          <div style="padding: 16px;" v-if="isOCRReading">
            <span class="mdi mdi-loading mdi-spin mdi-48px"></span>
            <p>現在履歴書を読み込んでおります。今しばらくお待ちください。</p>
          </div>
          <ResumeTable
            @modalOff="modalOff"
            :ocrData="ocrData"
            :seeker="null"
            :fileLeft="fileLeft"
            :fileRight="fileRight"
            :is-duplicate-seeker-flag="isDuplicateSeekerFlag"
            :is-get-robo-talk="isGetRoboTalk"
            v-if="!isOCRReading"
            :p-c-t-r-l-l-o-g="CTRLLOG"
          />
        </div>
      </div>
    </b-modal>
    <!-- モーダル END -->
    <ModalEditDate
      ref="editdate"
      @saveDate="saveDateFromModal"
      class="modal-edit-date"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import ModalEditDate from '@/components/ui/ModalEditDate';
import moment       from "moment"
import ResumeTable  from '@/views/DashBoard/Manage/ResumeTable'
import createUUID   from '@/functions/createUUID'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  components: {
    ResumeTable,
    ModalEditDate,
  },
  mixins: [
    controlLogMixin
  ],
  computed: {
    ...mapState('auth', ['user', 'users', 'manages']),
    ...mapState('directtalk', ['isOCRReading', 'ocrData']),
    formattedDate() {
      if (this.createSeeker.birth) {
        const date = new Date(this.createSeeker.birth);
        return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
      }
      return '';
    },
  },
  props: {
    companyColumnSetting: {
      type: Array,
      required: false
    },
    options: {
      type: Array,
      required: false
    },
    select_manages: {
      type: Array,
      required: false
    },
    blacklistSwitch: {
      type: Boolean,
      required: true,
    },
    currentManage: {
      type: Number
    },
    isDuplicateSeekerFlag: {
      type: Boolean,
      required: false,
      default: false,
    },
    isGetRoboTalk: {
      type: Boolean,
      required: false,
      default: false,
    },
    pulldownOptionsByColumnId: {
      type: Object,
      required: true
    },    
    getOptionsForColumn: {
      type: Function,
      required: true
    },    
  },
  data () {
    return {
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      year: 1920,
      month: 1,
      date: 1,
      tempSid: null,
      tempGrp: null,
      createSeeker: {
        sessionid: createUUID(),
        name: '',
        name_phonetic: null,
        sex: 0,
        email: null,
        tel: null,
        birth: null,
        address: null,
        message: null,
        group : null,
        progress_rate: 0,
        is_subscribe: true,
        subscribe_date: new Date(),
        subscribe_count: 1,
        recruitment_media_qualification: null,
        manage: [],
      },
      resume: {},
      imageUploadStep: 0,
      rirekisyoStep: 0,
      rirekisyoStepNew: 0,
      rirekisyoStepEdit: 0,
      isShowModal: false,
      shikakuData: {
        'shikaku_nen': null,
        'shikaku_tsuki': null,
        'shikaku': null
      },
      keirekiData: {
        'reki_nen': null,
        'reki_tsuki': null,
        'reki': null
      },
      shikakuTable: [],
      keirekiTable: [],
      keirekiTable2: [],
      fileLeft: null,
      fileRight: null,
      ocrResumeRows: [],
      data: '',
      select: null,
      start: null,
      end: null,
      editIndex: -1,
      isID         : '',
      isEdit       : '',
      isName       : '',
      isEmail      : '',
      isTel        : '',
      isAddress    : '',
      isStatus     : -1,
      isSex        : '',
      isJobOfferNo : '',
      isBirth      : this.year + '-' + this.month + '-' + this.date,
      isDate       : '',
      sexTypes  : ['', '男性', '女性', '選択しない'],
      custom: new Object(),
      isSubmitting: false  // 送信中かどうかを追跡するフラグ
    }
  },
  watch: {
    fileLeft () {
      let reader = new FileReader()
      console.log(this.fileLeft)
      reader.onload = (e) => {
        console.log(e)
        this.ocrResumeRows.push({
          filename: this.fileLeft.name,
          data: e.target.result.replace(/^.*,/, '')
        })
      }
      reader.readAsDataURL(this.fileLeft)
    },
    fileRight () {
      let reader = new FileReader()
      reader.onload = (e) => {
        console.log(e)
        this.ocrResumeRows.push({
          filename: this.fileRight.name,
          data: e.target.result.replace(/^.*,/, '')
        })
      }
      reader.readAsDataURL(this.fileRight)
    },
  },
  methods: {
    // モーダル用に列のオプションを取得
    getOptionsForColumnModal(columnId) {
      return this.getOptionsForColumn(columnId);
    },
    registerOCR () {
      this.$store.dispatch('directtalk/uploadOCR',this.ocrResumeRows)
      this.imageUploadStep++
    },
    initContent () {
      this.createSeeker = {
        sessionid: createUUID(),
        name: '',
        name_phonetic: null,
        sex: 0,
        email: null,
        tel: null,
        birth: null,
        address: null,
        message: null,
        group : null,
        progress_rate: 0,
        is_subscribe: true,
        subscribe_date: new Date(),
        subscribe_count: 1,
        recruitment_media_qualification: null,
        manage: [],
      }
      this.custom = new Object()
    },
    modalOff () {
      const getSeekerConditions = {
        is_archive: false,
        is_blacklist: this.blacklistSwitch,
        filter_type: false,
        filter: [],
        page: 1,
        perPage: 30,
        manageid: this.currentManage,
        is_duplicate_seeker_flag: this.isDuplicateSeekerFlag,
        is_get_robo_talk: this.isGetRoboTalk
      }
      const authUser = this.users.filter(i=>i.email === this.user.email)
      this.$store.dispatch('directtalk/getSubscribedSeekers', {conditions: getSeekerConditions, authUser: authUser, isAgent: this.user.isAgent})
      this.fileLeft  = null
      this.fileRight = null
      this.imageUploadStep = 0
      this.isShowModal = false
    },
    createSeekerMethod () {
      // 名前だけは入っているかチェック
      if (this.createSeeker.name.length === 0) {
        alert('名前は必ず入力してください。')
        return
      }
      
      // 送信中フラグをtrueに設定
      this.isSubmitting = true
      
      this.sendControlLog('新規応募者登録', '応募者の登録モーダルから、新規応募者を通常登録した。')
      let createSeekerTemp = this.createSeeker
      createSeekerTemp['group'] = this.user.companyID
      // 作成後のリロードで重複フラグが取得されるようにフラグを設定
      createSeekerTemp['is_duplicate_seeker_flag'] = this.isDuplicateSeekerFlag
      createSeekerTemp['is_get_robo_talk'] = this.isGetRoboTalk

      this.$store.dispatch('directtalk/createSeeker', createSeekerTemp)
        .then((d) => {
          const keys = Object.keys(this.custom)
          if (keys) {
            for (let v of keys) {
              let temp = this.companyColumnSetting.filter((obj) => {return obj.pk == v})
              if (temp.length > 0) {
                let createCustom = {
                  name: temp[0].name,
                  type: 0,
                  content: this.custom[v],
                  select_list: '',
                  column: v,
                  id: d.id
                }
                this.$store.dispatch('directtalk/createSeekerCustomColumns', createCustom)
              }
            }
          }
          this.initContent()
          this.modalOff()
          // 処理完了後、送信中フラグをfalseに戻す
          this.isSubmitting = false
        })
        .catch((error) => {
          // エラー時も送信中フラグをfalseに戻す
          this.isSubmitting = false
          console.error('応募者登録エラー:', error)
          alert('登録中にエラーが発生しました。もう一度お試しください。')
        })
    },
    openDatePicker() {
      this.$refs.editdate.changeDate = this.createSeeker.birth ? new Date(this.createSeeker.birth) : new Date(1980, 0, 1);
      this.$refs.editdate.toggle();
    },
    saveDateFromModal(data) {
      this.createSeeker.birth = data.date;
    },
  },
}
</script>

<style scoped>
table td:not([align]), table th:not([align]) {
  text-align: center;
}
table {
  width: 100%;
  border-collapse:collapse;
  margin: 0 auto;
}
td,th {
  padding:10px;
  margin: auto;
  max-width: 350px;
  font-size: smaller;
}
td {
  text-align: left;
}
th {
  color:#fff;
  background:#AA0066;
}
table tr:nth-child(odd) {
  background:#ffeeff;
}
table tr:nth-child(even) {
  background:#fafafa;
}
.header-box {
  width: calc(100% - 80px);
  margin: 10px 40px;
  margin-bottom: 25px;
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: dotted 6px #323;
  flex-wrap: wrap;
}
.header-menu {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
}
.main-box {
  width: 100%;
  padding: 0;
}
.table-list {
  border: solid thin #ccc;
  height: calc(100vh - 180px);
  overflow: scroll;
}
.export-box {
  height: calc(100vh - 130px);
  width: 100%;
}
.export-list {
  margin: 20px;
  margin-right: 5px;
  margin-left:  10px;
  height: calc(100% - 40px);
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background: rgba(200, 200, 200, 0.5);
  border-radius: 10px;
}
.export-list-header {
  background: rgba(0, 0, 0, 0.7);
  border-radius: 10px;
  width: 200px;
  height: 40px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  color: white;
  font-size: 16px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.export-list-body {
  border-radius: 10px;
  width: 190px;
  text-align: center;
  color: black;
  font-size: 16px;
  margin: 5px;
  margin-bottom: 0;
  padding: 10px;
  background: white;
  min-height: 44px;
}
.export-header {
  height: 50px;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.add-box {
  margin: 20px;
  margin-left: 5px;
  margin-right: 10px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  /* padding: 20px; */
  width: 210px;
  height: 40px;
}
.date-box {
  width: 40%;
  padding-left: 10px;
  padding-right: 10px;
  display: flex;
  justify-content: space-between
}
.option-box {
  width: 60%;
  padding-right: 10px; 
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 5px;
  overflow: scroll;
}
.resume-btn {
  border-radius: 50%;
  height: 36px;
  width: 36px;
  font-size: 16px;
}

.wrapper-cover-img {
  position: relative;
}

.input-box {
  text-align: left;
  width: 100%;
  display: flex;
  border-bottom: solid thin #ccc !important;
  border-right: solid thin #ccc !important;
  border-left: solid thin #ccc !important;
}
.input-label {
  width: 30%;
  border-right: solid thin #ccc !important;
  background: rgba(250, 230, 230) !important;
  padding: 8px !important;
}
.input-modal {
  width: calc(100% - 30%);
  height: 40px;
  color: #222 !important;
  font-size: 16px !important;
  background: #f8f8f8 !important;
  padding: 8px !important;
  border-radius: 0;
  border: none;
  box-shadow: none;
}

.table-box {
  width: 100%;
}
.table-box-header {
  border: solid thin #ccc !important;
  background: rgb(250, 230, 230) !important;
  color: #222;
  padding: 8px !important;
}
.input-table {
  height: 40px;
  color: #222 !important;
  font-size: 16px;
  background: #f8f8f8 !important;
  padding: 8px !important;
  border-radius: 0;
  box-shadow: none !important;
}
.container-birth{
  display: flex
}

.upload-button {
  width: 210px; height: 200px; background: #fdd; padding: 20px;
  transition: 0.3s;
  border-radius: 8px;
  cursor: pointer;
}
.upload-button:hover {
  transform: scale(1.05);
}
.newmake-button {
  margin-left: 24px; width: 210px; height: 200px; background: #dfd; padding: 20px;
  transition: 0.3s;
  border-radius: 8px;
  cursor: pointer;
}
.newmake-button:hover {
  transform: scale(1.05);
}

.tab-box-form {
  max-height: calc(85vh - 120px);
  width: 100%; display: flex; padding: 8px;
  flex-wrap: wrap;
}
.tab-box-left {
  width: 40%; display: flex; justify-content: flex-start; align-items: center;
}
.tab-box-right {
  width: 60%; font-size: 13px; padding: 10px; justify-content: flex-start; display: flex;
  flex-wrap: wrap;
}
.dot-line {
  height: 10px;
  width: 100%;
  background-image: url('../../../assets/lp/dot.png');
  background-repeat: repeat-x;
  background-size: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
}
.modal-edit-date {
  z-index: 100000 !important; /* 非常に高いz-indexを設定 */
}
/* Buefyのモーダルのz-indexを上書き */
.modal, .modal-background {
  z-index: 99999 !important;
}

/* 日付入力フィールドのスタイルを調整 */
.date-input-wrapper {
  width: 100%;
  cursor: pointer;
}

.date-input {
  width: 100%;
  cursor: pointer;
  background-color: #fff; /* 背景色を白に設定 */
  border: 1px solid #dbdbdb; /* 枠線を追加 */
  border-radius: 4px; /* 角を丸く */
  padding: 0.5rem; /* パディングを追加 */
  font-size: 0.875rem; /* フォントサイズを調整 */
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Manage/ModalCreate.vue